import { Injectable } from '@angular/core'
import { Router } from '@angular/router'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { of } from 'rxjs'
import { catchError, map, switchMap } from 'rxjs/operators'
import {
  FetchStreetGeoJsonFailure,
  FetchStreetGeoJsonRequest,
  FetchStreetGeoJsonSuccess,
} from './map.actions'
import { MapService } from './map.service'
import * as IndustriesTypes from './map.types'

@Injectable()
export class MapEffects {
  constructor(
    private actions: Actions,
    private mapService: MapService,
    private router: Router,
  ) {}

  FetchStreetGeoJson$ = createEffect(() =>
    this.actions.pipe(
      ofType(IndustriesTypes.FETCH_STREET_GEO_JSON_REQUEST),
      switchMap((action: FetchStreetGeoJsonRequest) => {
        return this.mapService.fetchStreetGeoJson(action.id).pipe(
          map((result) => {
            return new FetchStreetGeoJsonSuccess(result.data)
          }),
          catchError((err, caught) => {
            return of(new FetchStreetGeoJsonFailure({ error: err }))
          }),
        )
      }),
    ),
  )
}
